export default {
  // ===== COMMON =====
  'common.shopNow': '지금 구매하기',
  'common.whereToBuy': '구매처 안내',
  'common.learnMore': '자세히 알아보기',
  'common.readMore': '더 읽기',
  'common.subscribe': '구독하기',
  'common.submit': '제출하기',
  'common.download': '다운로드',
  'common.verify': '인증하기',
  'common.discover': '발견하기',
  'common.back': '뒤로',
  'common.next': '다음',
  'common.close': '닫기',
  'common.search': '검색',
  'common.filter': '필터',
  'common.loading': '로딩 중...',
  'common.freeShipping': '무료 배송',
  'common.over': '이상',
  'common.save': '저장',
  'common.from': '부터',
  'common.step': '스텝',
  'common.set': '세트',
  'common.officialStore': '공식 온라인 스토어',
  'common.partnerPharmacies': '제휴 약국',
  'common.onlineRetailers': '온라인 판매처',
  'common.getDirections': '길찾기',
  'common.call': '전화',
  'common.hours': '영업시간',
  'common.address': '주소',
  'common.contact': '연락처',
  'common.apply': '신청하기',
  'common.seeAll': '전체 보기',
  'common.viewDetails': '상세 보기',
  'common.addToCart': '장바구니 담기',
  'common.checkout': '결제하기',
  'common.placeOrder': '주문하기',
  'common.continueShopping': '쇼핑 계속하기',

  // ===== NAV =====
  'nav.brandStory': '브랜드 스토리',
  'nav.threeStep': '3-Step 트리트먼트',
  'nav.products': '제품',
  'nav.content': '콘텐츠',
  'nav.whereToBuy': '구매처',
  'nav.shop': '쇼핑',
  'nav.account': '계정',
  'nav.cart': '장바구니',

  // ===== FOOTER =====
  'footer.brandDesc': "방글라데시 최초의 더모코스메틱 K-뷰티 브랜드. 약사가 추천하는 임상 성분, 한국 혁신, 진짜 결과.",
  'footer.hotlineLabel': '핫라인',
  'footer.hotline': '+880 1XXX-XXXXXX',
  'footer.brand': '브랜드',
  'footer.products': '제품',
  'footer.support': '고객지원',
  'footer.brandStory': '브랜드 스토리',
  'footer.threeStepTreatment': '3-Step 트리트먼트',
  'footer.ourPhilosophy': '브랜드 철학',
  'footer.ingredientResearch': '성분 연구',
  'footer.step01': 'Step 01 — 스킨 프라이밍 부스터 에센스',
  'footer.step02': 'Step 02 — 데일리 레스큐 세럼',
  'footer.step03': 'Step 03 — 베리어 실 크림',
  'footer.threeStepSet': '3-Step 세트',
  'footer.shopAll': '전체 제품 보기',
  'footer.aboutUs': '회사 소개',
  'footer.contactUs': '문의하기',
  'footer.faq': '자주 묻는 질문',
  'footer.shippingReturns': '배송 및 반품',
  'footer.privacyPolicy': '개인정보 처리방침',
  'footer.termsOfService': '이용약관',
  'footer.copyright': '\u00a9 2026 The.K Seoul Co., Ltd. All rights reserved.',
  'footer.dgda': 'DGDA 등록: 진행 중',
  'footer.parentCompany': '모회사',
  'footer.marketingAuth': '\uD654\uC7A5\uD488\uCC45\uC784\uD310\uB9E4\uC5C5\uC790: \uC8FC\uC2DD\uD68C\uC0AC \uB354\uCF00\uC774\uC11C\uC6B8 (Korea)',
  'footer.manufacturer': '\uD654\uC7A5\uD488\uC81C\uC870\uC5C5\uC790: \uC815\uC778\uD654\uC7A5\uD488(\uC8FC) (Korea)',
  'footer.bdOperations': '\uBC29\uAE00\uB77C\uB370\uC2DC \uC2A4\uB9F9: Sol Grace Construction BD. Ltd. \u2014 Dhaka, Bangladesh',
  'footer.registeredAddress': '\uB4F1\uB85D \uC8FC\uC18C: Apt-A1, House 94, Park Road, Block-K, Baridhara, Dhaka-1212, Bangladesh',
  'footer.tradeLicense': '\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638: TRAD/DNCC/027028/2025',

  // ===== HOME HERO =====
  'home.hero.dailyTreatment': '3-Step 데일리 트리트먼트',
  'home.hero.prescription': '스킨케어 프리스크립션',
  'home.hero.kBeauty': '당신의 피부를 위해, K-Beauty',
  'home.hero.subtitle': '약사가 추천하는 임상 성분. 정품 보증. 3-Step 데일리 트리트먼트.',
  'home.hero.ctaProducts': '제품 보기',
  'home.hero.ctaWhereToBuy': '구매처 안내',
  'home.hero.statClean': '100% 클린',
  'home.hero.statCleanSub': '임상 등급',
  'home.hero.statDerma': 'K+ 더마',
  'home.hero.statDermaSub': '한국 혁신',
  'home.hero.statPrescribed': 'Rx 처방',
  'home.hero.statPrescribedSub': '약사 인증',
  'home.hero.scroll': '스크롤',
  'home.hero.trustBadge1': 'GMP 인증 제조',
  'home.hero.trustBadge2': '약사 인증 포뮬러',
  'home.hero.trustBadge3': 'DGDA 등록 심사 중',
  'home.hero.trustBadge4': '한국 제조',
  'home.hero.ctaShopSet': '3-Step 세트 구매 — ৳8,000\n(৳500 할인)',

  // ===== HOME BRAND STORY =====
  'home.brandStory.label': '브랜드 스토리',
  'home.brandStory.heading': '당신의 피부 처방이',
  'home.brandStory.subheading': 'K-뷰티를 만나는 곳',
  'home.brandStory.body': "Rx.K Seoul은 하나의 단순한 질문에서 시작했습니다: 효과적인 피부과 등급 스킨케어가 왜 접근하기 어려워야 할까요? 한국 R&D의 탁월함과 임상 등급 포뮬러를 결합해, 방글라데시 최초의 약국 화장품 K-뷰티 브랜드로 선보입니다. 모든 성분은 검증된 효능을 위해 선택되었고, 모든 스텝은 눈에 보이는 결과를 위해 처방되었습니다.",
  'home.brandStory.pillar1.title': 'Rx 처방',
  'home.brandStory.pillar1.sub': '임상 등급',
  'home.brandStory.pillar2.title': 'K-뷰티',
  'home.brandStory.pillar2.sub': '한국 혁신',
  'home.brandStory.pillar3.title': '베리어 리페어',
  'home.brandStory.pillar3.sub': '피부 보호',
  'home.brandStory.cta': '브랜드 스토리 읽기 →',
  'home.brandStory.est': '설립',
  'home.brandStory.year': '2026',
  'home.brandStory.seoul': '서울',

  // ===== HOME ROUTINE =====
  'home.routine.label': '데일리 리추얼',
  'home.routine.heading': '3-Step 데일리 트리트먼트',
  'home.routine.tagline': 'Open · Treat · Lock',
  'home.routine.cta': '전체 루틴 가이드 →',

  // ===== HOME LAUNCH GALLERY =====
  'home.launchGallery.eyebrow': '런치 쇼케이스 — K-GOODS FESTA 2026',
  'home.launchGallery.heading': 'K-뷰티가 방글라데시를 직접 만난 현장.',
  'home.launchGallery.subline': 'KOTRA 및 주방글라데시 대한민국 대사관 공동 주최 · Jamuna Future Park · 2026년 6월 19-20일',
  'home.launchGallery.caption.brandPanel': '과학이 처방하는, 당신을 위한 디자인',
  'home.launchGallery.caption.booth': 'K Seoul 파빌리온, Jamuna Future Park',
  'home.launchGallery.caption.consult': '과학 중심의 스킨케어 상담',
  'home.launchGallery.caption.crowd': 'Rx.K 테스팅 존의 성황',
  'home.launchGallery.caption.model': 'VIP 코너에서의 라이브 상담',
  'home.launchGallery.caption.model2': '3-Step 데일리 트리트먼트 체험',
  'home.launchGallery.caption.team': '방글라데시 x 한국 — 부스에서 함께한 팀',
  'home.launchGallery.caption.team2': '방글라데시 x 한국 — 부스에서 함께한 팀',
  'home.launchGallery.badge': 'Jamuna TV 출연',
  'home.launchGallery.cta': '3-Step 세트 알아보기 →',

  // ===== HOME CTA SPLIT =====
  'home.ctaSplit.left.brand': 'Rx+. K SEOUL',
  'home.ctaSplit.left.heading': '한국에서 온 K-Beauty를 경험하세요',
  'home.ctaSplit.right.heading': '오늘부터 루틴을 시작하세요',
  'home.ctaSplit.right.body': "방글라데시에서 약사가 추천하는 스킨케어로 전환한 수천 명의 고객과 함께하세요. 임상 성분, 한국 혁신, 진짜 결과 — 집 앞까지 배달됩니다.",
  'home.ctaSplit.right.step1': '01 OPEN',
  'home.ctaSplit.right.step2': '02 TREAT',
  'home.ctaSplit.right.step3': '03 LOCK',
  'home.ctaSplit.right.ctaShop': '지금 쇼핑 →',
  'home.ctaSplit.right.ctaWhere': '구매처 안내 →',
  'home.ctaSplit.stat1.label': '무료 배송',
  'home.ctaSplit.stat1.value': '৳3,000 이상',
  'home.ctaSplit.stat2.label': '적립 리워드',
  'home.ctaSplit.stat2.value': '10% 적립',
  'home.ctaSplit.stat3.label': '모든 제품',
  'home.ctaSplit.stat3.value': 'QR 인증',

  // ===== HOME ARTICLES =====
  'home.articles.label': '지식',
  'home.articles.heading': '스킨케어 인텔리전스',
  'home.articles.cta': '전체 아티클 →',

  // ===== HOME AUTHENTICITY =====
  'home.authenticity.label': '100% 정품 보증',
  'home.authenticity.subLabel': 'DGDA 등록 인증 시스템',
  'home.authenticity.heading': '스캔. 인증. 신뢰.',
  'home.authenticity.body': '모든 Rx.K Seoul 박스에는 고유한 QR 코드가 있습니다. 스캔하여 정품 판매인증 매장을 확인하세요 — 한국의 The.K Seoul Co., Ltd.에서 직접 검증됩니다.',
  'home.authenticity.cta': '제품 인증하기',
  'home.authenticity.badge': '제품의 QR을 스캔하세요',

  // ===== HOME NEWSLETTER =====
  'home.newsletter.heading': '소식 받기',
  'home.newsletter.body': '방글라데시 시장을 위한 스킨케어 팁, 성분 과학, 그리고 특별 혜택을 받아보세요.',
  'home.newsletter.placeholder': '이메일 주소를 입력하세요',
  'home.newsletter.submit': '구독하기',
  'home.newsletter.success': '구독해 주셔서 감사합니다! 환영 메시지를 확인하세요.',
  'home.newsletter.error': '유효한 이메일 주소를 입력해 주세요.',
  'home.newsletter.privacy': '구독하면 마케팅 이메일 수신에 동의하는 것입니다. 언제든지 해지할 수 있습니다.',

  // ===== HOME REVIEWS =====
  'home.reviews.label': '실제 후기',
  'home.reviews.heading': '피부가 말하는 진짜 후기',
  'home.reviews.subtext': '전 세계 Rx.K Seoul 고객들의 실제 사용 후기입니다.',

  // ===== BRAND STORY =====
  'brandV2.hero.journey': '브랜드 이야기',
  'brandV2.founder.label': '대표의 한마디',
  'brandV2.founder.quote': '가장 필요한 사람들에게 약국 수준의 한국 스킨케어를 전하고, 그들이 여는 모든 박스가 정품이도록 하기 위해 The.K Seoul을 시작했습니다.',
  'brandV2.glance.n1': '3',
  'brandV2.glance.l1': '하나의 루틴, 3단계',
  'brandV2.glance.n2': '37+',
  'brandV2.glance.l2': '다카 파트너 약국',
  'brandV2.glance.n3': '2026',
  'brandV2.glance.l3': '방글라데시 출시',
  'brandV2.glance.n4': '100%',
  'brandV2.glance.l4': '정품 확인 가능한 박스',
  'brandV2.film.label': '브랜드 필름',
  'brandV2.film.heading': 'Rx.K Seoul,',
  'brandV2.film.headingEm': '영상으로 만나다.',
  'brandV2.film.watch': '브랜드 필름 보기',
  'brandV2.founder.message': "한국 스킨케어는 전 세계에서 신뢰받지만, 방글라데시에서는 정품이라는 증거도, 우리 피부에 무엇이 맞는지에 대한 조언도 없이 팔리는 경우가 많습니다.\n그래서 우리는 약국처럼 Rx.K Seoul을 만들었습니다. 목적에 맞게 고른 성분의 간단한 루틴, 한국 제조, 배치별 검사, 그리고 모든 박스의 정품 확인.",
  'brandV2.company.label': "회사 소개",
  'brandV2.company.heading': "The.K Seoul Co., Ltd.",
  'brandV2.company.f1l': "모회사",
  'brandV2.company.f1v': "The.K Seoul Co., Ltd., 한국",
  'brandV2.company.f2l': "본사",
  'brandV2.company.f2v': "경기도 안양시",
  'brandV2.company.f3l': "제조사",
  'brandV2.company.f3v': "Jungin Cosmetics Co., Ltd., 한국",
  'brandV2.company.f4l': "방글라데시 법인",
  'brandV2.company.f4v': "Sol Grace Construction BD. Ltd., 다카",
  'brandV2.company.f5l': "방글라데시 출시",
  'brandV2.company.f5v': "2026년 6월 · K-Goods Festa, 다카",
  'brandV2.company.f6l': "사업자 등록",
  'brandV2.company.f6v': "TRAD/DNCC/027028/2025",
  'brandV2.company.family': "Rx.K Seoul · Pick.K Seoul · Medi.K Seoul",
  'brandV2.name.label': "브랜드",
  'brandV2.name.heading': "Rx.K Seoul의 의미",
  'brandV2.name.lead': "세 부분, 하나의 생각: 정성껏 처방한, 한국에서 만든, 당신의 피부를 위한 스킨케어.",
  'brandV2.name.rx.mark': "Rx",
  'brandV2.name.rx.title': "처방",
  'brandV2.name.rx.text': "이유가 있어 고른 포뮬러를 뜻하는 약국의 표시. 루틴의 모든 성분은 효과적인 농도로 제 역할을 합니다.",
  'brandV2.name.k.mark': "K",
  'brandV2.name.k.title': "한국",
  'brandV2.name.k.text': "한국 R&D로 개발하고 한국 GMP 시설에서 한국 약국 기준에 맞춰 제조합니다.",
  'brandV2.name.seoul.mark': "Seoul",
  'brandV2.name.seoul.title': "우리의 집",
  'brandV2.name.seoul.text': "모회사와 연구팀이 있는 곳, 모든 배치가 다카로 떠나는 출발점.",
  'brandV2.founder.word': "FOUNDER",
  'brandV2.brands.rxk': "약사가 큐레이션한 더모코스메틱 스킨케어, 방글라데시 피부를 위해 한국에서 제조.",
  'brandV2.brands.pickk': "방글라데시 크리에이터와 한국 제품을 연결하는 초대제 B2B 플랫폼.",
  'brandV2.brands.medik': "서울 의료관광: 피부, 성형, 치과, 건강검진 파트너 클리닉.",
  'brandV2.brands.here': "현재 사이트",
  'brandV2.company.familyLabel': "The.K Seoul 패밀리",
  'brandV2.company.tagLabel': "The.K Seoul",
  'brandV2.company.tag': "신뢰할 수 있는 K-커머스의 글로벌 브리지",
  'brandV2.company.routeFrom': "연구개발 및 제조",
  'brandV2.company.routeTo': "방글라데시 운영",
  'brandV2.company.familyHeading': "세 개의 브랜드, 하나의 신뢰 기준",
  'brandV2.name.result': "약국의 정성, 한국의 품질, 서울의 마음",
  'brandV2.manifesto.quote': '약국과 화장품의 만남. 처방하는 뷰티.',
  'brandV2.manifesto.text': 'Rx.K Seoul은 서울의 더모코스메틱 브랜드입니다. 약사가 고른 성분, 한국 제조, 그리고 방글라데시 피부를 위한 간단한 루틴.',
  'brandV2.journey.label': '서울에서 당신에게',
  'brandV2.journey.heading': '모든 박스는',
  'brandV2.journey.headingEm': '공장까지 추적됩니다.',
  'brandV2.journey.step1.title': '서울에서 개발',
  'brandV2.journey.step1.text': '한국 R&D의 약사 큐레이션 포뮬러.',
  'brandV2.journey.step2.title': 'GMP 시설에서 제조',
  'brandV2.journey.step2.text': '엄격한 품질 관리를 거친 한국 공장.',
  'brandV2.journey.step3.title': '배치 추적',
  'brandV2.journey.step3.text': '서울에서 다카까지 모든 배치를 추적합니다.',
  'brandV2.journey.step4.title': '모든 박스에 QR',
  'brandV2.journey.step4.text': '은색 홀로그램을 스캔해 몇 초 만에 확인하세요.',
  'brandV2.journey.step5.title': '문 앞까지',
  'brandV2.journey.step5.text': '공식 채널을 통해서만. 배송 시 결제.',
  'brandV2.journey.verify': '정품 확인하기',
  'brandV2.cta.shop': '3-Step 세트 보기',
  'brandStory.hero.label': '브랜드 스토리',
  'brandStory.hero.heading': '서울에서 온 K-Beauty가',
  'brandStory.hero.subheading': '\u00A0 \u00A0당신의 피부와 만나는 곳\u00A0 \u00A0',
  'brandStory.hero.subtitle': '방글라데시 최초의 더마코스메틱 K-뷰티 브랜드',
  'brandStory.problem.label': '문제',
  'brandStory.problem.heading': 'K-뷰티의 신뢰 공백',
  'brandStory.problem.p1': "방글라데시의 K-뷰티 시장은 폭발적으로 성장하고 있지만, 문제 역시 커지고 있습니다. 위조 제품이 온라인 마켓에 진입하여 의심스러운 가격에 판매되고, 소비자들은 정품 여부를 확인할 방법이 없습니다. 다카, 치타공, 실렛의 소비자들은 가짜, 유통기한이 지난, 또는 해로운 제품에 소중한 돈을 쓰고 있습니다.",
  'brandStory.problem.p2': "제품이 정품일 때조차, 대부분의 소비자는 남아시아 피부 고민에 실제로 효과 있는 성분이 무엇인지 모릅니다 — 열대 햇볕으로 인한 기미, 불균일한 피부톤, 습도와 미세먼지로 손상된 장벽, 다카의 기후로 악화되는 여드름. 그들은 약사가 처방할 것이 아니라 인플루언서가 추천하는 제품을 삽니다.",
  'brandStory.problem.p3': '결과는? 낭비된 돈, 손상된 피부 장벽, 그리고 사람들이 자신의 피부에 자신감을 가질 수 있게 도와야 할 카테고리에 대한 점점 커지는 불신입니다.',
  'brandStory.problem.stat1': '70%+',
  'brandStory.problem.stat1Label': '미인증 채널의 위조품 위험',
  'brandStory.problem.stat2': '0',
  'brandStory.problem.stat2Label': '방글라데시 더모코스메틱 K-뷰티 브랜드',
  'brandStory.problem.stat3': '৳12,000+',
  'brandStory.problem.stat3Label': '효과 없는 제품에 대한 연간 평균 지출',
  'brandStory.solution.label': '우리의 솔루션',
  'brandStory.solution.heading': 'Rx.K Seoul - 한국에서 온 당신 피부의 K-뷰티 솔루션',
  'brandStory.solution.body': '더모코스메틱 — 약국과 화장품의 만남. 약사가 엄선한 성분 선택과 한국 R&D의 탁월함을 결합하여, 접근 가능한 가격에 임상 등급 포뮬러를 전달합니다. 모든 제품은 목적을 위해 선택되고, 안전을 위해 테스트되며, 정품을 위해 검증되도록 설계되었습니다.',
  'brandStory.solution.feature1.title': '임상 신뢰',
  'brandStory.solution.feature1.point1': '약사가 큐레이팅한 포뮬러',
  'brandStory.solution.feature1.point2': '남아시아 피부에 피부과 테스트 완료',
  'brandStory.solution.feature1.point3': '한국 제약 제조 기준',
  'brandStory.solution.feature1.point4': '임상적으로 유효한 농도의 활성 성분',
  'brandStory.solution.feature2.title': '정품 보증',
  'brandStory.solution.feature2.point1': '모든 제품 박스에 고유 QR 코드',
  'brandStory.solution.feature2.point2': '스캔하면 즉시 인증 확인',
  'brandStory.solution.feature2.point3': '공식 인증 채널에서만 판매',
  'brandStory.solution.feature2.point4': '서울 공장에서 고객 문 앞까지 배치 추적',
  'brandStory.solution.feature3.title': '심플한 루틴',
  'brandStory.solution.feature3.point1': '3단계 — 혼란 없이, 10단계 압도감 없이',
  'brandStory.solution.feature3.point2': "방글라데시의 열대 기후를 위해 설계",
  'brandStory.solution.feature3.point3': '다카의 습도와 몬순 시즌에도 작동',
  'brandStory.solution.feature3.point4': '마케팅 hype가 아닌 실효적인 농도',
  'brandStory.madeFor.label': '당신을 위해 설계',
  'brandStory.madeFor.heading': '남아시아인 피부를 위해 설계',
  'brandStory.madeFor.p1': '남아시아 피부는 대부분의 범용 K-뷰티 브랜드가 무시하는 독특한 특성을 가지고 있습니다. 높은 멜라닌 함량은 다른 색소 침착 패턴을 의미합니다. 열대 습도는 가벼운 비코메도제닉 질감을 요구합니다. 그리고 끊임없는 자외선 손상과의 싸움은 표면적 브라이트닝보다 더 깊이 작용하는 성분을 필요로 합니다.',
  'brandStory.madeFor.p2': "우리는 이러한 고민을 위해 Rx.K Seoul 루틴의 모든 성분을 특별히 선택했습니다. 나이아신아마이드 5%는 세포 수준에서 색소 침착을 표적으로 합니다. 나이아신아마이드 2%와 PHA/LHA는 무거움 없이 다층 수분을 공급합니다. 세라마이드 NP는 다카의 습도와 미세먼지가 끊임없이 손상시키는 장벽을 재건합니다.",
  'brandStory.madeFor.cta': '3-Step 트리트먼트 알아보기 →',
  'brandStory.madeFor.concern1.title': '열대 자외선 손상',
  'brandStory.madeFor.concern1.desc': '연중 내내 자외선 노출로 인한 기미와 다크스팟',
  'brandStory.madeFor.concern2.title': '습도와 미세먼지',
  'brandStory.madeFor.concern2.desc': "다카 도심 환경에서의 장벽 손상과 모공 막힘",
  'brandStory.madeFor.concern3.title': '불균일한 피부톤',
  'brandStory.madeFor.concern3.desc': '멜라닌이 풍부한 피부에서 흔한 염증 후 색소 침착',
  'brandStory.madeFor.concern4.title': '장벽 민감성',
  'brandStory.madeFor.concern4.desc': '가혹한 제품과 기후 스트레스로 손상된 피부 장벽',
  'brandStory.company.label': '모회사',
  'brandStory.company.heading': 'The.K Seoul 에서 만듭니다.',
  'brandStory.company.p1': 'The.K Seoul Co., Ltd.는 피부과 등급 스킨케어를 가장 필요로 하는 시장에 전달하겠다는 사명으로 설립된 한국 뷰티 기업입니다. 서울 기반 R&D 팀은 한국 피부과 전문의와 약사들과 협력하여 한국 제약 기준과 열대 기후의 특별한 요구를 모두 충족하는 포뮬러를 개발합니다.',
  'brandStory.company.p2': '모든 배치는 GMP 인증 한국 시설에서 제조되며, 엄격한 품질 관리를 거치고, 공장을 떠나기 전 피부과 테스트를 완료합니다. Rx.K Seoul을 사용할 때, 당신은 한국 약국이 요구하는 동일한 기준을 사용하고 있습니다.',
  'brandStory.company.signatureName': 'Jack Daniel',
  'brandStory.company.signatureCaption': 'Jack Daniel, The.K Seoul Co., Ltd.',
  'brandStory.company.stat1': 'KOREA',
  'brandStory.company.stat1Label': '한국 제조',
  'brandStory.company.stat2': 'GMP',
  'brandStory.company.stat2Label': 'GMP 인증',
  'brandStory.company.stat3': 'TESTED',
  'brandStory.company.stat3Label': '피부과 테스트 완료',
  'brandStory.cta.heading': '\u00A0 \u00A0 K뷰티로 처방된 아름다움을 경험하세요',
  'brandStory.cta.body': "방글라데시 최초의 프리스크립션 K-뷰티 커뮤니티에 참여하세요. 임상 성분, 한국 혁신, 진짜 결과 — ৳2,500부터 시작합니다.",
  'brandStory.cta.downloadBrochure': '브로셔 다운로드',

  // ===== 3-STEP TREATMENT =====
  'threeStep.hero.label': '데일리 리추얼',
  'threeStep.hero.heading': '\u00A0 3-Step 데일리 트리트먼트\u00A0',
  'threeStep.hero.subtitle': '당신의 아름다운 피부를 위한 매일 처방. Open · Treat · Lock.',
  'threeStep.philosophy.label': '철학',
  'threeStep.philosophy.heading': '왜 3단계인가?',
  'threeStep.philosophy.p1': "K-뷰티는 정교한 10단계 루틴으로 유명합니다. 하지만 피부과 의사들이 아는 사실은: 대부분의 단계는 선택 사항입니다. 스킨케어의 과학은 모든 피부 타입이 매일 필요로 하는 세 가지 필수 작용으로 요약됩니다.",
  'threeStep.philosophy.prep': 'Prep',
  'threeStep.philosophy.prepDesc': '피부 장벽의 수분을 보충합니다.',
  'threeStep.philosophy.treat': 'Treat',
  'threeStep.philosophy.treatDesc': '특정 고민을 타겟팅해서 도움되는 활성 성분을 전달합니다.',
  'threeStep.philosophy.seal': 'Seal',
  'threeStep.philosophy.sealDesc': '활성 성분을 봉인하고 환경적 손상으로부터 방어합니다.',
  'threeStep.philosophy.p2': 'Rx.K Seoul은 임상 피부과학을 누구나 따를 수 있는 루틴으로 정제합니다 — 아침과 저녁, 5분 이내. 혼란 없이, 압도감 없이, 처방된 결과만.',
  'threeStep.step01.badge': 'OPEN',
  'threeStep.step01.name': '스킨 프라이밍 부스터 에센스',
  'threeStep.step01.subtitle': '프라임. 브라이트닝. 부스트.',
  'threeStep.step01.price': '৳2,500',
  'threeStep.step01.volume': '50ml',
  'threeStep.step01.desc': '필수 첫 단계. 나이아신아마이드 2%가 피부톤을 밝고 균일하게 만들고, PHA/LHA가 표면 각질을 부드럽게 제거해 매끄러운 캔버스를 만듭니다. 히알루론산이 다층 수분을 공급하고, 센텔라 아시아티카가 염증을 진정시키며 회복을 돕습니다. 이제 당신의 피부는 프라임되고, 밝아지고, 트리트먼트를 받을 준비가 되었습니다.',
  'threeStep.step01.ingredientsLabel': '핵심 성분',
  'threeStep.step01.howToUse': '사용법',
  'threeStep.step01.use1': '클렌징 후 젖은 피부에 바릅니다',
  'threeStep.step01.use2': '손바닥에 2-3펌프를 덜어냅니다',
  'threeStep.step01.use3': '얼굴과 목에 부드럽게 두드려 흡수시킵니다',
  'threeStep.step01.use4': 'Step 02 전 30초간 기다립니다',
  'threeStep.step01.cta': '스킨 프라이밍 부스터 에센스 구매 →',
  'threeStep.step02.badge': 'TREAT',
  'threeStep.step02.name': '데일리 레스큐 세럼',
  'threeStep.step02.subtitle': '리페어. 강화. 회복.',
  'threeStep.step02.price': '৳2,800',
  'threeStep.step02.volume': '50ml',
  'threeStep.step02.desc': '트리트먼트의 핵심. 나이아신아마이드 5%가 세포 수준에서 다크스팟, 염증 후 색소 침착, 불균일한 톤을 타겟팅합니다. 트라넥삼산 1-2%가 기미와 PIH를 임상적으로 감소시킵니다. 펩타이드가 피부 회복을 가속화하고 콜라겐을 증가시킵니다. 세라마이드 NP가 지질 장벽을 강화해 더 강하고 회복력 있는 피부를 만듭니다.',
  'threeStep.step02.ingredientsLabel': '핵심 성분',
  'threeStep.step02.howToUse': '사용법',
  'threeStep.step02.use1': '스킨 프라이밍 부스터 에센스가 완전히 흡수된 후',
  'threeStep.step02.use2': '펌프를 한 번 눌러 1회 분량을 덜어냅니다',
  'threeStep.step02.use3': '얼굴과 목에 고르게 바릅니다',
  'threeStep.step02.use4': '60초간 흡수를 기다립니다',
  'threeStep.step02.use5': '즉시 Step 03으로 넘어갑니다',
  'threeStep.step02.cta': '데일리 레스큐 세럼 구매 →',
  'threeStep.step03.badge': 'LOCK',
  'threeStep.step03.name': '베리어 실 크림',
  'threeStep.step03.subtitle': '봉인. 보호. 유지.',
  'threeStep.step03.price': '৳3,200',
  'threeStep.step03.volume': '50ml',
  'threeStep.step03.desc': "보호의 마지막 단계. 세라마이드 NP가 피부의 지질 장벽을 재건합니다 — 바로 그 장벽이 다카의 습도와 미세먼지가 끊임없이 손상시키는 것입니다. 비코메도제닉 에몰리언트인 스쿠알란이 모공을 막지 않고 Step 02의 모든 활성 성분을 봉인합니다. 코코-카프릴레이트/카프레이트는 무겁거나 기름지지 않은 실키한 수분을 전달합니다.",
  'threeStep.step03.ingredientsLabel': '핵심 성분',
  'threeStep.step03.howToUse': '사용법',
  'threeStep.step03.use1': '세럼이 완전히 흡수된 후 (60초)',
  'threeStep.step03.use2': '완두콩 크기만큼 덜어 손끝에서 따뜻하게 합니다',
  'threeStep.step03.use3': '얼굴과 목에 부드럽게 눌러줍니다 — 문지르지 마세요',
  'threeStep.step03.use4': '추가 보호를 위해 데콜테까지 연장합니다',
  'threeStep.step03.use5': '선크림이나 메이크업 전 3분간 기다립니다',
  'threeStep.step03.cta': '베리어 실 크림 구매 →',
  'threeStep.climate.label': '기후 가이드',
  'threeStep.climate.heading': "방글라데시 기후에 맞춤 설계",
  'threeStep.climate.hot.title': '더운 & 습한',
  'threeStep.climate.hot.subtitle': '3월 – 10월',
  'threeStep.climate.hot.tip1': '습한 날씨에는 피부가 피지를 더 많이 분비하므로 베리어 실 크림을 더 가볍게 바릅니다',
  'threeStep.climate.hot.tip2': '스킨 프라이밍 부스터 에센스의 나이아신아마이드 2%와 PHA/LHA가 습한 공기에서 수분을 끌어와 추가적인 광채를 줍니다',
  'threeStep.climate.hot.tip3': '항상 Step 3 후 선크림을 바르세요. 이 기간 동안 자외선 노출이 가장 높습니다',
  'threeStep.climate.hot.tip4': '제품은 직사광선을 피해 서늘하고 건조한 곳에 보관하세요',
  'threeStep.climate.hot.tip5': '정오에 피부가 기름지게 느껴지면 부드럽게 두드려 제거하세요 — 과도하게 세안하지 마세요',
  'threeStep.climate.cool.title': '선선한 & 건조한',
  'threeStep.climate.cool.subtitle': '11월 – 2월',
  'threeStep.climate.cool.tip1': '건조한 공기는 피부 수분 증발을 증가시키므로 스킨 프라이밍 부스터를 넉넉하게 바릅니다',
  'threeStep.climate.cool.tip2': '밤새 수분을 봉인하기 위해 베리어 실 크림을 권장량만큼 충분히 사용하세요',
  'threeStep.climate.cool.tip3': '데일리 레스큐 세럼은 선선한 밤에 밤새 회복에 탁월하게 작동합니다',
  'threeStep.climate.cool.tip4': '추가적인 환경 수분을 위해 침실에 가습기를 사용하는 것을 고려하세요',
  'threeStep.climate.cool.tip5': '건조한 부위(볼, 코 주변)에는 베리어 실 크림을 더 바르세요',
  'threeStep.timeline.label': '예상 결과',
  'threeStep.timeline.heading': '결과 타임라인',
  'threeStep.timeline.m1.period': '3일',
  'threeStep.timeline.m1.title': '눈에 띄게 촉촉해진 피부',
  'threeStep.timeline.m1.desc': '피부가 더 부드럽고, 매끄럽고, 편안하게 느껴집니다. 나이아신아마이드 2%와 PHA/LHA가 즉시 밝고 매끄러운 표면 텍스처를 만들기 시작합니다.',
  'threeStep.timeline.m2.period': '2주',
  'threeStep.timeline.m2.title': '더 매끄럽고 균일한 텍스처',
  'threeStep.timeline.m2.desc': '모공이 정돈되어 보입니다. 피부 텍스처가 눈에 띄게 매끄러워집니다. 나이아신아마이드 5%와 트라넥삼산이 피지를 조절하고 색소 침착을 옅게 하기 시작합니다.',
  'threeStep.timeline.m3.period': '4-6주',
  'threeStep.timeline.m3.title': '다크스팟 현저히 감소',
  'threeStep.timeline.m3.desc': '염증 후 색소 침착이 옅어집니다. 피부톤이 더 균일하고 러미너스해집니다. 세라마이드 NP와 스쿠알란 장벽이 더 강해져 피부가 더 회복력 있게 됩니다.',
  'threeStep.faq.label': 'FAQ',
  'threeStep.faq.heading': '자주 묻는 질문',
  'threeStep.faq.q1': '3단계 모두 필요한가요, 아니면 하나만 써도 되나요?',
  'threeStep.faq.a1': '각 단계는 고유한 목적을 가지고 있습니다. Step 01 (스킨 프라이밍 부스터 에센스)는 수분을 공급하고 피부를 준비합니다. Step 02 (데일리 레스큐 세럼)는 활성 트리트먼트 성분을 전달합니다. Step 03 (베리어 실 크림)은 모든 것을 봉인하고 보호합니다. 세 가지를 함께 사용하면 각 단계가 다음 단계를 향상시키는 시너지 효과가 발생합니다. 하지만 처음 시작하시는 분이라면 Step 01부터 시작하여 피부가 적응하는 대로 나머지를 점진적으로 추가하세요.',
  'threeStep.faq.q2': '눈에 보이는 결과가 나타나려면 얼마나 걸리나요?',
  'threeStep.faq.a2': '수분 개선은 즉시 — 첫 번째 사용 후 차이를 느끼실 수 있습니다. 텍스처와 톤 개선은 일반적으로 2주 내에 나타납니다. 다크스팟 감소와 현저한 색소 침착 옅어짐은 나이아신아마이드가 세포 수준에서 작용하므로 꾸준한 사용 4-6주가 필요합니다. 개인의 피부 상태, 기후, 꾸준함에 따라 결과는 달라집니다.',
  'threeStep.faq.q3': '민감성 피부에도 적합한가요?',
  'threeStep.faq.a3': '네. 세 가지 제품 모두 흔한 자극 성분 없이 제조되었습니다: 인공 향료 없음, 알코올 데낫 없음, 에센셜 오일 없음, 가혹한 각질 제거 성분 없음. 나이아신아마이드 5%와 트라넥삼산, 펩타이드는 민감성 피부를 포함한 대부분의 피부 타입에서 잘 견딥니다. 매우 민감하신 분은 Step 01만 일주일간 사용한 후 Step 02를 추가하고, 그 다음 Step 03을 추가하시는 것을 권장합니다. 전체 얼굴 사용 전 귀 뒤에 48시간 패치 테스트를 항상 해주세요.',
  'threeStep.faq.q4': '남성도 이 루틴을 사용할 수 있나요?',
  'threeStep.faq.a4': '물론입니다. 피부는 성별과 상관없이 피부입니다. 남성은 종종 더 두껍고 기름진 피부와 큰 모공을 가지고 있으며 — Step 02의 나이아신아마이드는 과도한 피지를 조절하고 모공을 정돈하는 데 특히 효과적입니다. 다카의 많은 초기 사용자는 기존 K-뷰티의 복잡함 없이 심플하고 효과적인 루틴을 원했던 남성들입니다.',
  'threeStep.faq.q5': '이미 다른 제품을 사용 중이라면요?',
  'threeStep.faq.a5': 'Rx.K Seoul은 현재 핵심 루틴을 대체하도록 설계되었습니다. 선크림(필수)과 부드러운 클렌저는 계속 사용하실 수 있습니다. 비타민 C, 레티놀, AHA/BHA와 같은 다른 고농도 활성 성분은 같은 루틴에 섞지 마세요 — 우리의 3-Step 트리트먼트와 번갈아 사용하세요(예: 월요일은 활성 성분, 화요일은 Rx.K Seoul).',
  'threeStep.cta.heading': '3-Step 세트로 완성하세요',
  'threeStep.cta.price': '৳8,000',
  'threeStep.cta.originalPrice': '৳8,500',
  'threeStep.cta.save': '৳500 할인',
  'threeStep.cta.desc': '스킨 프라이밍 부스터 에센스 (50ml) + 데일리 레스큐 세럼 (50ml) + 베리어 실 크림 (50ml). 당신의 매일 처방에 필요한 모든 것.',
  'common.buyNow': '바로 구매',
  'threeStep.buy.setLabel': '3단계 풀세트',
  'threeStep.buy.giftBox': '선물 상자 포함',
  'threeStep.buy.cod': '착불 결제 가능',
  'threeStep.buy.madeInKorea': '한국 제조',

  // ===== PRODUCTS =====
  'products.hero.label': '제품',
  'products.hero.heading': '프리스크립션 컬렉션',
  'products.hero.subtitle': '방글라데시를 위해 약사가 큐레이팅한 임상 등급 포뮬러.',
  'products.hero.cta': '3-Step 세트 쇼핑',
  'products.allProducts': '전체 제품',
  'products.categories': '카테고리',
  'products.step01': 'Step 01 — OPEN',
  'products.step02': 'Step 02 — TREAT',
  'products.step03': 'Step 03 — LOCK',
  'products.set': '3-Step 세트',
  'products.viewDetails': '상세 보기',
  'products.ingredients': '핵심 성분',
  'products.howToUse': '사용법',
  'products.clinicalClaims': '임상 클레임',
  'products.suggestedUse': '권장 사용법',
  'products.size': '용량',
  'products.relatedProducts': '관련 제품',
  'products.fullRoutine': '전체 루틴',
  'products.seeAll': '전체 제품 보기',

  // ===== VERIFY =====
  'verify.hero.label': '정품 인증',
  'verify.hero.heading': '제품 인증하기',
  'verify.hero.subtitle': '제품에 있는 QR 코드를 스캔하여 정품 여부를 확인하고 배치 정보를 확인하세요.',
  'verify.instruction.title': '인증 방법',
  'verify.instruction.step1': '제품 박스의 QR 코드 스티커를 찾으세요.',
  'verify.instruction.step2': 'QR 리더나 카메라 앱으로 스캔하세요.',
  'verify.instruction.step3': '배치 번호, 제조일, 정품 상태를 확인하세요.',
  'verify.instruction.step4': '인증에 실패하면 문의해 주세요 — 모든 제품을 보증합니다.',
  'verify.demo.title': '샘플 인증 결과',
  'verify.demo.product': '제품',
  'verify.demo.batch': '배치',
  'verify.demo.status': '상태',
  'verify.demo.date': '제조일',
  'verify.demo.authentic': '정품',
  'verify.input.label': '제품 코드',
  'verify.input.placeholder': '예: XXXX-XXXX-XXXX',
  'verify.input.button': '인증하기',
  'verify.input.checking': '확인 중…',
  'verify.result.authentic.title': '정품 확인됨',
  'verify.result.authentic.body': '이 코드는 등록되어 있습니다 — {{product}}은(는) 정품 Rx.K Seoul 제품입니다.',
  'verify.result.authentic.firstVerified': '최초 인증일',
  'verify.result.field.product': '제품명',
  'verify.result.field.batch': '배치 번호',
  'verify.result.field.mfgDate': '제조일',
  'verify.result.field.expiryDate': '유효기간',
  'verify.result.field.firstScan': '최초 스캔',
  'verify.result.field.scanCount': '스캔 횟수',
  'verify.result.field.company': '제조사',
  'verify.result.field.companyValue': 'The.K Seoul',
  'verify.result.suspicious.title': '여러 번 스캔됨',
  'verify.result.suspicious.body': '이 코드는 이미 여러 번 스캔되었습니다. 위조품이 의심되시면 고객센터로 문의해 주세요.',
  'verify.result.serial.title': '박스 일련번호입니다',
  'verify.result.serial.body': '{{code}}는 바코드 아래에 인쇄된 재고 번호이며 인증 코드가 아닙니다. 정품 확인은 휴대폰 카메라로 은색 홀로그램 스티커(“Scan to Verify”)의 QR 코드를 스캔해 주세요.',
  'verify.result.notfound.title': '위조 제품입니다',
  'verify.result.notfound.body': '이 코드는 저희 시스템에 등록된 정품 The.K Seoul 제품과 일치하지 않습니다 — 이것은 저희의 정품이 아닌 위조품입니다. 즉시 사용을 중단하시고 고객센터로 문의해 주세요.',
  'verify.result.error': '문제가 발생했습니다 — 다시 시도해 주세요.',
  'verify.trust.title': '정품이 왜 중요한가',
  'verify.trust.body': '위조 화장품은 해로운 성분을 포함할 수 있습니다. Rx.K Seoul은 QR 인증 시스템, 배치 추적, 그리고 공식 판매 채널만을 통해 모든 제품을 보증합니다.',
  'verify.cta': '자신 있게 쇼핑하기',

  // ===== WHERE TO BUY =====
  'whereToBuy.hero.label': '판매처',
  'whereToBuy.hero.heading': '구매처 안내',
  'whereToBuy.hero.subtitle': '방글라데시 전역의 공식 약국과 온라인 스토어에서 Rx.K Seoul을 만나보세요.',
  'whereToBuy.online.title': '공식 온라인 스토어',
  'whereToBuy.online.subtitle': '৳3,000 이상 주문 시 무료 배송. QR 인증 정품.',
  'whereToBuy.online.cta': '지금 쇼핑 →',
  'whereToBuy.pharmacy.title': '공식 판매 약국',
  'whereToBuy.pharmacy.subtitle': '파트너 약국을 방문하여 직접 상담하고 구매하세요.',
  'whereToBuy.retail.title': '리테일 파트너',
  'whereToBuy.retail.subtitle': 'Rx.K Seoul 제품을 취급하는 선별 리테일 매장.',
  'whereToBuy.map.title': '매장 검색',
  'whereToBuy.map.subtitle': '가장 가까운 공식 판매점을 찾아보세요.',
  'whereToBuy.trust.title': '100% 정품 보증',
  'whereToBuy.trust.body': '공식 채널을 통해 판매되는 모든 제품은 QR 인증과 배치 추적이 포함됩니다. 위조품을 의심하신다면 즉시 신고해 주세요.',
  'whereToBuy.filter.all': '전체',
  'whereToBuy.filter.pharmacy': '약국',
  'whereToBuy.filter.online': '온라인',
  'whereToBuy.filter.retail': '리테일',

  // ===== CONTENT =====
  'content.hero.label': '지식',
  'content.hero.heading': '스킨케어 인텔리전스',
  'content.hero.subtitle': '약사와 연구진이 전하는 과학적 근거 기반의 스킨케어 지식.',
  'content.categories': '카테고리',
  'content.allArticles': '전체 아티클',
  'content.readTime': '분 소요',
  'content.author': '글',
  'content.published': '발행일',
  'content.relatedArticles': '관련 아티클',
  'content.backToHub': '콘텐츠 허브로 돌아가기',

  // ===== ABOUT =====
  'about.hero.label': '소개',
  'about.hero.heading': 'Rx.K Seoul 소개',
  'about.mission.label': '사명',
  'about.mission.heading': '처방된 아름다움.',
  'about.mission.body': '우리는 효과적인 스킨케어가 사치품이나 도박이 되어서는 안 된다고 믿습니다. 모든 Rx.K Seoul 제품은 제약 과학의 엄격함과 한국 뷰티 혁신의 우아함으로 개발됩니다.',
  'about.values.label': '가치',
  'about.values.heading': '우리가 지키는 것',

  // ===== CONTACT =====
  'contact.hero.label': '문의',
  'contact.hero.heading': '도움이 필요하신가요',
  'contact.form.name': '이름',
  'contact.form.email': '이메일',
  'contact.form.phone': '전화번호',
  'contact.form.subject': '제목',
  'contact.form.message': '메시지',
  'contact.form.submit': '문의 보내기',
  'contact.form.success': '감사합니다! 24시간 이내에 답변 드리겠습니다.',
  'contact.info.title': '연락처 정보',
  'contact.info.email': '이메일',
  'contact.info.phone': '전화',
  'contact.info.address': '주소',
  'contact.info.hours': '영업시간',

  // ===== FAQ =====
  'faq.hero.label': '고객지원',
  'faq.hero.heading': '자주 묻는 질문',
  'faq.hero.subtitle': '약사 팀에서 드리는 답변입니다.',

  // FAQ Group Titles
  'faq.groupA.title': '제품 사용법',
  'faq.groupB.title': '정품 인증',
  'faq.groupC.title': '배송 및 반품',
  'faq.groupD.title': '약국 파트너십',

  // Group A — Product Usage
  'faq.groupA.q1.question': '결과가 나타나려면 얼마나 걸리나요?',
  'faq.groupA.q1.answer': '첫 수분 개선: 약 3일. 더 매끄러운 텍스처: 약 2주. 다크스팟 현저한 감소: 4–6주. 꾸준함이 양보다 중요합니다.',
  'faq.groupA.q2.question': '기존 스킨케어와 함께 Rx.K Seoul을 사용할 수 있나요?',
  'faq.groupA.q2.answer': '네. 3-Step 루틴은 대부분의 스킨케어 루틴에서 토너/에센스/세럼/모이스처라이저를 대체합니다. 선크림(SPF 30+ 이상)은 별도로 계속 사용하세요.',
  'faq.groupA.q3.question': '임신 중에도 이 루틴을 사용해도 안전한가요?',
  'faq.groupA.q3.answer': '세 가지 제품 모두 레티노이드와 임신 주의 성분으로 분류된 고농도 활성 성분을 배제했습니다. 임신 중 새로운 스킨케어를 추가하기 전에 산부인과 의사와 상담하세요.',
  'faq.groupA.q4.question': '남성도 Rx.K Seoul을 사용할 수 있나요?',
  'faq.groupA.q4.answer': '네. 모든 포뮬러는 피부과 테스트를 완료했으며 비코메도제닉으로, 모든 성인 피부에 적합합니다.',
  'faq.groupA.q5.question': '한 번 사용할 때 얼마나 바르나요?',
  'faq.groupA.q5.answer': '부스터: 2–3펌프. 세럼: 1펌프. 크림: 완두콩 크기.',

  // Group B — Authenticity & Verification
  'faq.groupB.q1.question': '제품이 정품인지 어떻게 확인하나요?',
  'faq.groupB.q1.answer': '모든 Rx.K Seoul 박스 뒷면에는 고유한 QR 코드가 있습니다. /verify 페이지에서 스캔하면 배치 번호, 제조일, 공식 판매처를 확인할 수 있습니다. 인증에 실패하면 즉시 문의해 주세요.',
  'faq.groupB.q2.question': '온라인에서 구매했는데 QR이 작동하지 않아요 — 어떻게 해야 하나요?',
  'faq.groupB.q2.answer': '/contact 페이지에서 위조품 신고를 제출하세요. 판매자 이름, 구매일, 박스와 QR의 사진을 첨부해 주세요. 모든 신고는 48시간 이내에 조사합니다.',
  'faq.groupB.q3.question': 'Rx.K Seoul을 가장 안전하게 구매할 수 있는 곳은 어디인가요?',
  'faq.groupB.q3.answer': '공식 온라인 스토어와 /buy 페이지에 나열된 공식 판매 약국 파트너입니다. 온라인 마켓플레이스(Daraz Mall 등)에서는 판매자가 "The.K Seoul Co., Ltd." 또는 공식 파트너일 때만 구매하세요.',

  // Group C — Shipping & Returns
  'faq.groupC.q1.question': '배송은 얼마나 걸리나요?',
  'faq.groupC.q1.answer': '다카: 1–2영업일. 다카 외 방글라데시 도시: 2–4영업일.',
  'faq.groupC.q2.question': '배송비는 무료인가요?',
  'faq.groupC.q2.answer': '৳3,000 이상 주문 시 무료입니다. ৳3,000 미만 주문 시 배송비 ৳120이 적용됩니다.',
  'faq.groupC.q3.question': '제품을 반품할 수 있나요?',
  'faq.groupC.q3.answer': '미개봉 제품은 배송일로부터 7일 이내에 반품 가능합니다. 개봉한 스킨케어는 결함이 아닌 한 위생상의 이유로 반품이 불가능합니다. 도움이 필요하면 문의해 주세요.',
  'faq.groupC.q4.question': '마일리지 리워드는 어떻게 작동하나요?',
  'faq.groupC.q4.answer': '모든 주문 시 결제금액의 10%를 Rx.K 포인트로 적립합니다. 결제 시 사용 가능합니다(1포인트 = ৳1).',

  // Group D — Pharmacy Partnership
  'faq.groupD.q1.question': '공식 판매처가 되려면 어떻게 해야 하나요?',
  'faq.groupD.q1.answer': '/partner-apply에서 신청하세요. 국가 영업 디렉터(Selim Reza)가 5영업일 이내에 마진 조건, POSM 지원, 초도 주문 세부사항으로 답변 드립니다.',
  'faq.groupD.q2.question': '파트너는 어떤 마진을 받나요?',
  'faq.groupD.q2.answer': '표준 약국 마진 조건이 적용되며, 추가적인 판매처 유도 인센티브가 있습니다. 세부사항은 파트너십 대화 중에 공유됩니다.',
  'faq.groupD.q3.question': '판매처 자료(POSM)를 제공하나요?',
  'faq.groupD.q3.answer': '네 — 카운터 디스플레이, 샘플 사셋, 약사 교육 브로셔, 성분 레퍼런스 카드를 제공합니다.',

  // ===== SHIPPING & RETURNS =====
  'shipping.hero.label': '정책',
  'shipping.hero.heading': '배송 및 반품',
  'shipping.dhaka.title': '다카 배송',
  'shipping.dhaka.desc': '표준 배송. 배송비 {{price}}.',
  'shipping.dhaka.time': '영업일 5일',
  'shipping.outside.title': '다카 외 지역',
  'shipping.outside.desc': '표준 배송. 배송비 {{price}}.',
  'shipping.outside.time': '영업일 10일',
  'shipping.free.title': '무료 배송',
  'shipping.free.desc': '{{threshold}} 이상 주문 시 무료 배송.',
  'shipping.returns.title': '반품 정책',
  'shipping.returns.desc': '개봉하지 않은 제품은 배송일로부터 14일 이내 반품 가능합니다. 개봉한 제품은 위생상의 이유로 반품이 불가합니다.',
  'shipping.track.title': '주문 추적',
  'shipping.track.desc': '모든 주문은 SMS와 이메일 업데이트를 통해 추적됩니다.',

  // ===== PRIVACY POLICY =====
  'privacy.hero.label': '법률',
  'privacy.hero.heading': '개인정보 처리방침',
  'privacy.lastUpdated': '최종 수정일: 2026년 5월',

  // ===== TERMS OF SERVICE =====
  'terms.hero.label': '법률',
  'terms.hero.heading': '이용약관',
  'terms.lastUpdated': '최종 수정일: 2026년 5월',

  // ===== CART / CHECKOUT / ORDER =====
  'cart.yourCart': '장바구니',
  'cart.empty': '장바구니가 비어있습니다',
  'cart.removed': '장바구니에서 제거되었습니다',
  'cart.added': '장바구니에 담았습니다 ✓',
  'cart.viewCart': '장바구니 보기 →',
  'cart.subtotal': '소계',
  'cart.shipping': '배송비',
  'cart.shippingCalculated': '결제 시 계산됩니다',
  'cart.free': '무료',
  'cart.total': '합계',
  'checkout.title': '결제',
  'checkout.contact': '연락처 정보',
  'checkout.contactShipping': '연락처 및 배송지',
  'checkout.fullName': '성명',
  'checkout.phone': '전화번호',
  'checkout.email': '이메일 (선택)',
  'checkout.shipping': '배송 주소',
  'checkout.address1': '전체 주소',
  'checkout.address2': '주소 2 (선택)',
  'checkout.selectDistrict': '지역(District) 선택',
  'checkout.selectThana': '타나(Thana) 선택',
  'checkout.searchDistrict': '지역 검색…',
  'checkout.searchThana': '타나 검색…',
  'checkout.postalCode': '우편번호 (선택)',
  'checkout.deliveryNote': '배송 메모',
  'checkout.addDeliveryNote': '배송 메모 추가',
  'checkout.deliveryNotePlaceholder': '배송 관련 특별 요청사항 (선택)',
  'checkout.payment': '결제 수단',
  'checkout.cod': '현금 결제 (COD)',
  'checkout.comingSoon': '준비 중',
  'checkout.orderSummary': '주문 요약',
  'checkout.agreePrefix': '아래 내용을 읽고 동의합니다:',
  'checkout.termsLink': '이용약관',
  'checkout.privacyLink': '개인정보처리방침',
  'checkout.agreeAnd': '및',
  'checkout.returnsLink': '반품/환불 정책',
  'checkout.freeShippingNote': '৳{{threshold}} 이상 주문 시 무료 배송',
  'checkout.haveCoupon': '쿠폰 코드가 있으신가요?',
  'checkout.couponPlaceholder': '코드 입력',
  'checkout.apply': '적용',
  'checkout.remove': '제거',
  'checkout.discount': '할인',
  'checkout.comboDiscount': '콤보 할인',
  'checkout.giftBox': '기프트 박스 추가',
  'checkout.giftBoxIncluded': '기프트 박스 포함',
  'checkout.couponApplied': '쿠폰이 적용되었습니다',
  'checkout.authenticityGuaranteed': '정품 보증',
  'checkout.secureCheckout': '안전한 결제',
  'order.thankYou': '주문해 주셔서 감사합니다!',
  'order.orderId': '주문번호',
  'order.estimatedDelivery': '예상 배송일',
  'order.businessDays': '영업일',
  'order.outsideDhaka': '다카 외 지역',
  'order.orderDetails': '주문 상세',
  'order.notFound': '주문을 찾을 수 없습니다',
  'order.authenticityGuaranteed': '정품 보증',
  'order.verifyQR': 'QR로 인증하기',
  'order.invoice': '인보이스',
  'order.invoiceFrom': '보내는 사람',
  'order.invoiceTo': '받는 사람',
  'order.description': '설명',
  'order.qty': '수량',
  'order.unitPrice': '단가',
  'order.amount': '금액',
  'order.tax': '세금',
  'order.paymentTerms': '결제 조건',
  'order.notes': '비고',
  'stickyBar.product': '3-Step 데일리 트리트먼트 세트',
  'stickyBar.save': '(৳500 할인)',
  'home.hero.ctaShopSet': '3-Step 세트 구매 — ৳8,000 (৳500 할인)',

  // ===== COMMON ADDITIONS =====
  'common.select': '선택',
  'common.submitting': '제출 중...',
  'common.max': '최대 글자수',

  // ===== PRODUCT DETAIL ADDITIONS =====
  'products.clickToZoom': '클릭하여 확대',
  'products.sizeGuide': '사이즈 가이드',
  'products.realSize': '실제 크기',
  'products.sizeGuideDesc': '평균 성인 손바닥과 비교한 실제 제품 크기입니다.',
  'products.howToUseVideo': '사용법 — 비디오 튜토리얼',
  'products.watchTutorial': '사용 튜토리얼 시청하기',
  'products.ingredientScience': '성분 사이언스',
  'products.inciName': 'INCI 명칭',
  'products.clinicalEvidence': '임상 근거',
  'products.benefit': '핵심 효능',
  'products.clinicalResults': '임상 연구 결과',
  'products.clinicalSubtitle': '8주 임상 연구 기준',
  'products.week4': '4주차',
  'products.week8': '8주차',
  'products.clinicalDisclaimer': '8주 임상 연구, n=42명 기준. 개인별 결과는 상이할 수 있습니다.',
  'products.reviews': '리뷰',
  'products.verifiedPurchases': '인증된 구매',
  'products.filterAll': '전체',
  'products.filterPhotos': '사진만',
  'products.verified': '인증된 구매',
  'products.productFAQ': '제품 Q&A',
  'products.askQuestion': '이 제품에 대해 질문하기',
  'products.loginToAsk': '질문하려면 로그인하세요',
  'products.questionPlaceholder': '이 제품에 대해 궁금한 점을 알려주세요',
  'products.submitQuestion': '질문 제출',
  'products.questionSubmitted': '감사합니다! 마이페이지 → Q&A에서 답변을 확인하실 수 있습니다.',
  'products.questionSubmitError': '질문을 제출할 수 없습니다. 다시 시도해주세요.',
  'products.crossSell': '루틴 완성하기',
  'products.writeReview': '리뷰 작성하기',
  'products.yourRating': '평점',
  'products.yourSkinType': '피부 타입 (선택 사항)',
  'products.selectSkinType': '피부 타입 선택',
  'products.reviewPlaceholder': '이 제품에 대한 경험을 공유해주세요…',
  'products.submitReview': '리뷰 제출',
  'products.loginToReview': '리뷰를 작성하려면 로그인하세요',
  'products.reviewSubmitted': '감사합니다! 리뷰가 승인 대기 중입니다.',
  'products.reviewSubmitError': '리뷰를 제출할 수 없습니다. 다시 시도해주세요.',
  'products.reviewPending': '제출하신 리뷰는 승인 대기 중입니다.',
  'products.reviewRejected': '제출하신 리뷰는 게시가 승인되지 않았습니다.',

  // ===== WHERE TO BUY ADDITIONS =====
  'whereToBuy.officialStore': '공식 온라인 스토어',
  'whereToBuy.shopDirect': 'rxk.thekseoul.com에서 직접 구매',
  'whereToBuy.shopNow': '지금 쇼핑 →',
  'whereToBuy.comingSoon': '곧 공개',
  'whereToBuy.mapPlaceholder': '지도 연동 준비 중. 주요 파트너 지역은 아래를 참고하세요.',
  'whereToBuy.poweredBy': 'Powered by Google Maps (연동 준비 중)',
  'whereToBuy.searchPlaceholder': '지역 또는 약국 이름 검색',
  'whereToBuy.filterArea': '지역',
  'whereToBuy.filterType': '유형',
  'whereToBuy.showingResults': '{{total}}개 매장 중 {{count}}개 표시',
  'whereToBuy.partnerApply': '파트너 신청',
  'whereToBuy.partnerApplyDesc': 'Rx.K Seoul을 약국이나 리테일 매장에서 취급하고 싶으신가요?',
  'whereToBuy.applyNow': '지금 신청 →',
  'whereToBuy.authenticityGuaranteed': '✓ 정품 보증',
  'whereToBuy.qrVerify': '제품 박스의 QR을 스캔하여 즉시 정품을 인증하세요.',
  'whereToBuy.morePartners.title': '더 많은 파트너가 공개됩니다',
  'whereToBuy.morePartners.desc': '방글라데시 전역의 인증 약국 파트너를 순차 공개합니다',
  'whereToBuy.morePartners.cta': '파트너 신청하기 →',
  'whereToBuy.authorizedPartners.heading': '공식 약국 파트너 — 2026년 6월 말 공개',
  'whereToBuy.authorizedPartners.description':
    '다카, 치타공, 실헷 전역에서 파트너 약국을 모집하고 있습니다. 공식 인증 판매처의 전체 목록은 2026년 7월 1일 방글라데시 공식 런칭에 맞춰 2026년 6월 말에 공개될 예정입니다. 약국 파트너로 참여하고 싶으시다면 아래에서 신청해 주세요.',
  'whereToBuy.authorizedPartners.button': '파트너 신청하기 →',
  'whereToBuy.showingOne': '1개 매장 표시',
  'whereToBuy.reportCounterfeit': '위조 제품을 발견하셨나요? 여기에서 신고해 주세요.',
  'whereToBuy.reportLink': '신고하기 →',

  // ===== PARTNER APPLY =====
  'partnerApply.hero.label': '파트너',
  'partnerApply.hero.heading': 'Rx.K Seoul 파트너 되기',
  'partnerApply.hero.subtitle': '공식 리테일 네트워크에 참여하여 약사가 추천하는 K-뷰티를 고객에게 전달하세요.',
  'partnerApply.form.businessName': '사업자명',
  'partnerApply.form.businessType': '사업 유형',
  'partnerApply.form.typePharmacy': '약국',
  'partnerApply.form.typeBeauty': '뷰티 리테일',
  'partnerApply.form.typeOnline': '온라인 스토어',
  'partnerApply.form.typeDistributor': '유통업체',
  'partnerApply.form.contactPerson': '담당자',
  'partnerApply.form.email': '이메일',
  'partnerApply.form.phone': '전화번호',
  'partnerApply.form.address': '사업장 주소',
  'partnerApply.form.mapLink': '구글 지도 링크 (선택)',
  'partnerApply.form.mapLinkHint': '구글 지도에서 사업장을 검색한 후 공유를 눌러 링크를 붙여넣으세요',
  'partnerApply.form.drugLicenseNo': '약국/의약품 판매 면허번호',
  'partnerApply.form.tinNo': 'TIN 번호',
  'partnerApply.form.nidNo': '신분증(NID) 번호',
  'partnerApply.form.binNo': 'BIN 번호 (선택)',
  'partnerApply.form.city': '도시',
  'partnerApply.form.cityDhaka': '다카',
  'partnerApply.form.cityChittagong': '치타공',
  'partnerApply.form.citySylhet': '실렛',
  'partnerApply.form.cityOthers': '기타',
  'partnerApply.form.volume': '월간 예상 판매량',
  'partnerApply.form.volume1': '100개 미만',
  'partnerApply.form.volume2': '100–500개',
  'partnerApply.form.volume3': '500–1000개',
  'partnerApply.form.volume4': '1000개 이상',
  'partnerApply.form.whyPartner': '파트너 신청 이유',
  'partnerApply.form.whyPlaceholder': '사업 소개와 파트너 신청 이유를 적어주세요 (선택)',
  'partnerApply.form.documentsTitle': '필수 제출 서류',
  'partnerApply.form.docDrugLicense': '의약품 판매 면허증',
  'partnerApply.form.docTin': 'TIN 증명서',
  'partnerApply.form.docNid': '신분증(NID)',
  'partnerApply.form.docPhoto': '신청자 사진',
  'partnerApply.form.docBin': 'BIN 증명서 (선택)',
  'partnerApply.form.docBankSolvency': '은행 지급여력 증명서 (선택)',
  'partnerApply.form.docBankStatement': '최근 6개월 은행 거래내역서 (선택)',
  'partnerApply.form.chooseFile': '파일 선택',
  'partnerApply.form.submit': '신청서 제출',
  'partnerApply.benefits.title': '파트너 혜택',
  'partnerApply.benefits.brandSupport': '공식 브랜드 지원 및 마케팅 자료',
  'partnerApply.benefits.training': '제품 교육 제공',
  'partnerApply.benefits.exclusive': '독점 영역 보호',
  'partnerApply.benefits.margin': '경쟁력 있는 도매 마진',
  'partnerApply.success.title': '신청 완료',
  'partnerApply.success.body': '관심을 가져 주셔서 감사합니다. 파트너십 팀이 신청서를 검토하고 3영업일 이내에 연락드리겠습니다.',
  'partnerApply.success.back': '구매처 안내로 돌아가기',

  // ===== HOME NAVBAR =====
  'home.nav.brandStory': '브랜드 스토리',
  'home.nav.routine': '루틴',
  'home.nav.products': '제품',
  'home.nav.whereToBuy': '구매처',
  'home.nav.ourProducts': '제품 보기',
  'home.nav.menuOpen': '메뉴 열기',

  // ===== HOME FOOTER =====
  'home.footer.brand': '브랜드',
  'home.footer.products': '제품',
  'home.footer.contact': '문의',
  'home.footer.brandStory': '브랜드 스토리',
  'home.footer.philosophy': '철학',
  'home.footer.ingredientResearch': '성분 연구',
  'home.footer.sustainability': '지속가능성',
  'home.footer.step01': 'Step 01 — 부스터 에센스',
  'home.footer.step02': 'Step 02 — 데일리 레스큐 세럼',
  'home.footer.step03': 'Step 03 — 베리어 실 크림',
  'home.footer.routineGuide': '루틴 가이드',
  'home.footer.email': 'hello@rxkseoul.com',
  'home.footer.kakao': '카카오 채널: @rxkseoul',
  'home.footer.address': '서울특별시 강남구',
  'home.footer.whereToBuy': '구매처 안내 →',
  'home.footer.privacy': '개인정보처리방침',
  'home.footer.terms': '이용약관',
  'home.footer.madeInKorea': 'MADE IN KOREA',

  // ===== HOME WHERE TO BUY SECTION =====
  'home.whereToBuySection.label': '구매',
  'home.whereToBuySection.heading': '구매처 안내',
  'home.whereToBuySection.desc': '온라인과 오프라인 모두에서 Rx.K Seoul을 만나보세요',
  'home.whereToBuySection.seeAll': '전체 보기',

  // ===== HOME CTA SECTION =====
  'home.ctaSection.left.brandLabel': 'Rx.K Seoul / rxk.thekseou.com',
  'home.ctaSection.left.heading': '처방된 아름다움을 경험하세요',
  'home.ctaSection.left.subtitle': '3-Step Daily Derma Reset Routine',
  'home.ctaSection.right.heading': '지금 바로 시작하세요',
  'home.ctaSection.right.body': '서울의 피부과학과 K-Beauty 감성이 만나는 Rx.K Seoul의 3-Step Routine으로 당신의 피부를 새롭게 처방받으세요.',
  'home.ctaSection.right.ctaProducts': '제품 보기 →',
  'home.ctaSection.right.ctaWhereToBuy': '구매처 안내 →',
  'home.ctaSection.stats.freeShipping': '무료 배송',
  'home.ctaSection.stats.freeShippingValue': '₩50,000 이상',
  'home.ctaSection.stats.returns': '반품',
  'home.ctaSection.stats.returnsValue': '30일 이내',
  'home.ctaSection.stats.support': '고객지원',
  'home.ctaSection.stats.supportValue': '24/7 카카오',

  // ===== HOME HERO =====
  'home.hero.product01': '스킨 프라이밍 부스터 에센스',
  'home.hero.product02': '데일리 레스큐 세럼',
  'home.hero.product03': '베리어 실 크림',
  'home.hero.statDermaLabel': 'K+ Derma',
  'home.hero.statPrescribedLabel': 'Rx 처방',

  // ===== COMMON ADDITIONS =====
  'common.remove': '제거',
  'common.decrease': '감소',
  'common.increase': '증가',
  'common.item': '개',
  'common.items': '개',
  'common.sending': '보내는 중...',
  'common.all': '전체',

  // ===== ABOUT =====
  'about.hero.subtitle': '2026년부터 한국의 제약 전문성과 방글라데시의 스킨케어 니즈를 연결합니다.',
  'about.story.heading': '브랜드 스토리',
  'about.story.p1': '주식회사 더케이서울은 서울 기반의 더모코스메틱 기업으로, 진정성 있고 임상 검증된 제품으로 소외되었던 시장에 처방 등급의 한국 스킨케어를 전달하겠다는 단 하나의 사명으로 설립되었습니다.',
  'about.story.p2': 'Rx.K Seoul은 우리의 플래그십 브랜드로, 한국의 제약 R&D와 열대 기후 및 남아시아 흔한 피부 고민에 맞춘 포뮬러를 결합하여 방글라데시를 위해 특별히 개발된 최초의 더모코스메틱 라인입니다.',
  'about.values.pillar1.title': '약사 주도',
  'about.values.pillar1.desc': '모든 포뮬러는 마케터가 아닌, 라이선스를 보유한 약사들이 개발하고 검토합니다.',
  'about.values.pillar2.title': '임상 농도',
  'about.values.pillar2.desc': '동료 심사를 거친 피부과 연구에서 효능이 입증된 농도의 활성 성분을 사용합니다.',
  'about.values.pillar3.title': '완전한 추적성',
  'about.values.pillar3.desc': '모든 제품에는 고유한 인증 코드가 있습니다. 스캔하여 즉시 정품 여부를 확인하세요.',
  'about.company.heading': '회사 정보',
  'about.company.siteDesc': 'Rx.K Seoul(rxk.thekseoul.com)은 방글라데시에서 The.K Seoul 더모코스메틱 스킨케어 제품을 온라인으로 판매하기 위해 운영되는 전자상거래 웹사이트입니다.',
  'about.company.concern': 'The.K Seoul은 Sol Grace Construction BD. Ltd.의 사업체입니다.',
  'about.company.entity': 'Sol Grace Construction BD. Ltd.',
  'about.company.bin': 'BIN(사업자식별번호): 009212412-0108',
  'about.company.tin': 'TIN(납세자번호): 520132321674',
  'about.company.address': '주소: 2/2-A, South Begunbari, Tejgaon I/A, Dhaka-1208, Bangladesh',
  'about.company.tradeLicense': '영업 허가증(Trade License): TRAD/DNCC/027028/2025',

  // ===== CONTACT =====
  'contact.hero.subtitle': 'Rx.K Seoul의 다카 사무실과 한국 본사에 연락하세요.',
  'contact.channels.email.label': '이메일',
  'contact.channels.email.value': 'hello@thekseoul.com',
  'contact.channels.email.note': '공식 이메일 주소는 추후 공개될 예정입니다',
  'contact.channels.whatsapp.label': 'WhatsApp / 전화 (방글라데시)',
  'contact.channels.whatsapp.value': '+880 1331-661166',
  'contact.channels.whatsapp.note': '월–토, 10:00–19:00 BST',
  'contact.channels.hq.label': '한국 본사',
  'contact.channels.hq.value': '주식회사 더케이서울',
  'contact.channels.hq.note': '경기도 안양시, 대한민국',
  'contact.sendMessage.heading': '메시지 보내기',
  'contact.form.namePlaceholder': '성명을 입력하세요',
  'contact.form.emailPlaceholder': 'your@email.com',
  'contact.form.phoneHelper': '+880 접두사 선택사항',
  'contact.form.subjectPlaceholder': '주제를 선택하세요',
  'contact.form.subjectProductInquiry': '제품 문의',
  'contact.form.subjectPharmacyPartnership': '약국 파트너십',
  'contact.form.subjectInfluencer': '인플루언서 협업',
  'contact.form.subjectMediK': 'Medi.K Seoul 의료관광 문의',
  'contact.form.subjectPickK': 'Pick.K Seoul 인플루언서 프로그램',
  'contact.form.subjectCounterfeit': '위조품 신고',
  'contact.form.subjectOther': '기타',
  'contact.form.messagePlaceholder': '어떻게 도와드릴까요?',
  'contact.form.maxChars': '최대 500자',
  'contact.form.messageMinError': '메시지는 최소 20자 이상 입력해 주세요.',
  'contact.form.consent': 'Rx.K Seoul이 문의 내용에 대해 연락하는 것에 동의합니다.',
  'contact.form.sending': '보내는 중...',
  'contact.form.sendAnother': '다시 보내기',
  'contact.success.heading': '메시지 전송 완료',
  'contact.success.body': '문의해 주셔서 감사합니다. 24시간 이내에 답변 드리겠습니다.',
  'contact.success.toast': '감사합니다. 2영업일 이내에 답변 드리겠습니다.',
  'contact.offices.bd.title': '방글라데시 운영',
  'contact.offices.bd.company': 'Sol Grace Construction BD. Ltd.',
  'contact.offices.bd.address': 'Apt-A1, House 94, Park Road, Block-K, Baridhara, Dhaka-1212, Bangladesh',
  'contact.offices.korea.title': '한국 본사',
  'contact.offices.korea.company': '주식회사 더케이서울',
  'contact.offices.korea.address': '경기도 안양시, 대한민국 (정확한 주소 추후 공개)',

  'faq.bottom.title': '추가 질문이 있으신가요?',
  'faq.bottom.body': '지원팀이 도와드리겠습니다. 언제든지 문의해 주세요.',
  'faq.bottom.cta': '고객지원 문의 →',

  // ===== SHIPPING & RETURNS =====
  'shipping.hero.subtitle': '방글라데시 전역으로 빠르고 믿을 수 있는 배송, 그리고 간편한 반품 서비스.',
  'shipping.options.heading': '배송 옵션',
  'shipping.returns.heading': '반품·환불·취소 정책',
  'shipping.returns.desc': '구매하신 제품에 완전히 만족하실 수 있도록 최선을 다합니다. 만족하지 못하셨다면, 반품 과정은 간단하고 손쉽습니다.',
  'shipping.step1.title': '반품 신청',
  'shipping.step1.desc': '배송일로부터 7일 이내에 support@rxkseoul.com으로 주문번호와 함께 반품을 신청하세요.',
  'shipping.step2.title': '제품 발송',
  'shipping.step2.desc': '미사용 및 미개봉 제품을 원래 포장 상태로 포장해 주세요. 반품 라벨을 제공해 드립니다.',
  'shipping.step3.title': '환불 처리',
  'shipping.step3.desc': '반품 제품을 수령하고 검수 후, 7~10 영업일 이내에 환불이 처리됩니다.',
  'shipping.conditions.heading': '반품 조건',
  'shipping.condition1': '제품은 미사용, 미개봉 상태이며 원래 포장과 모든 실링이 손상되지 않은 상태여야 합니다.',
  'shipping.condition2': '반품 신청은 배송일로부터 7일 이내에 제출되어야 합니다.',
  'shipping.condition3': '원래 주문번호와 인증 코드를 반드시 제공해야 합니다.',
  'shipping.condition4': '개봉, 사용, 또는 손상된 제품(결함 제외)은 반품 대상이 아닙니다.',
  'shipping.condition5': '미인증 판매처에서 구매한 제품은 반품 및 보증 대상이 아닙니다.',
  'shipping.refundTimeline.heading': '환불 처리 기간',
  'shipping.refundTimeline.desc': '반품된 제품을 수령하고 검수한 후, 승인된 환불은 7~10 영업일 이내에 원 결제 수단으로(대금교환(COD) 주문의 경우 비카시/계좌이체로) 처리됩니다. 환불이 처리되면 이메일로 확인 안내를 보내드립니다.',
  'shipping.cancellation.heading': '주문 취소',
  'shipping.cancellation.desc': '발송 전이라면 언제든지 주문번호와 함께 support@rxkseoul.com 또는 WhatsApp으로 연락하여 무료로 주문을 취소할 수 있습니다. 배송을 위해 발송된 이후에는 주문을 취소할 수 없으며, 위의 표준 반품 정책이 대신 적용됩니다.',

  // ===== PRIVACY POLICY =====
  'privacy.section1.title': '1. 소개',
  'privacy.section1.body': '주식회사 더케이서울("우리", "당사")은 귀하의 개인정보를 존중하며 보호하기 위해 최선을 다하고 있습니다. 본 개인정보 처리방침은 Rx.K Seoul 웹사이트, 제품 및 서비스 이용 시 당사가 귀하의 정보를 어떻게 수집, 사용, 저장 및 보호하는지 설명합니다.',
  'privacy.section2.title': '2. 수집하는 정보',
  'privacy.section2.body': `당사는 다음과 같은 유형의 정보를 수집할 수 있습니다:

• 개인정보: 구매 또는 계정 등록 시 제공한 이름, 이메일 주소, 전화번호, 배송 주소, 결제 정보.
• 주문 정보: 제품 선택, 구매 내역, 스캔한 인증 코드, 거래 세부정보.
• 기술 정보: 웹사이트 기능 및 분석을 위한 IP 주소, 브라우저 유형, 기기 정보, 쿠키.
• 커뮤니케이션 데이터: 문의 양식 또는 지원 채널을 통해 제출된 메시지, 문의, 피드백.`,
  'privacy.section3.title': '3. 정보의 사용 목적',
  'privacy.section3.body': `귀하의 정보는 다음 목적을 위해 사용됩니다:

• 주문 처리 및 이행, 배송 및 전달 포함.
• 제품 정품 인증 및 위조 방지 추적.
• 고객 지원, 문의 응답 및 문제 해결.
• 주문 확인, 배송 업데이트 및 중요한 제품 정보 전송.
• 사용 분석을 기반으로 웹사이트, 제품 및 서비스 개선.`,
  'privacy.section4.title': '4. 데이터 저장 및 보안',
  'privacy.section4.body': '당사는 업계 표준 암호화 및 보안 프로토콜을 사용하는 Supabase의 보안 서버에 데이터를 저장합니다. 귀하의 개인정보는 마케팅 목적으로 제3자에게 판매, 임대 또는 공유되지 않습니다. 당사는 본 정책에 명시된 목적 또는 관련 법률에서 요구하는 기간 동안만 데이터를 보관합니다.',
  'privacy.section5.title': '5. 귀하의 권리',
  'privacy.section5.body': `귀하는 다음의 권리를 가지고 있습니다:

• 개인정보에 대한 접근, 업데이트 또는 수정.
• 법적 보관 요건에 따른 조건 하에 개인 데이터 삭제 요청.
• 언제든지 마케팅 커뮤니케이션 수신 거부.
• 권리가 침해되었다고 생각하는 경우 데이터 보호 당국에 불만 제기.`,
  'privacy.section6.title': '6. 문의하기',
  'privacy.section6.body': '본 개인정보 처리방침에 대한 질문이나 우려 사항이 있으시면 support@rxkseoul.com으로 문의해 주세요.',

  // ===== TERMS OF SERVICE =====
  'terms.section1.title': '1. 약관의 수락',
  'terms.section1.body': 'Rx.K Seoul 웹사이트, 제품 또는 서비스에 접근하거나 이용함으로써, 귀하는 본 이용약관에 동의하는 것입니다. 본 약관에 동의하지 않으시면 서비스를 이용하지 마세요. 당사는 언제든지 본 약관을 업데이트하거나 수정할 권리를 보유하며, 계속적인 이용은 개정된 약관에 대한 동의를 의미합니다.',
  'terms.section2.title': '2. 제품 및 구매',
  'terms.section2.body': `모든 제품 설명, 가격 및 재고는 예고 없이 변경될 수 있습니다. 당사는 정확한 색상과 세부정보를 표시하기 위해 노력하지만, 화면 설정에 따라 실제 제품 외관이 약간 다를 수 있습니다. 가격은 방글라데시 타카(৳)로 표시되며, 달리 명시되지 않은 한 적용 가능한 세금이 포함됩니다.

당사는 제품 재고, 제품 또는 가격 정보의 오류, 또는 사기 의심 활동 등을 포함하되 이에 국한되지 않는 이유로 주문을 거부하거나 취소할 권리를 보유합니다.`,
  'terms.section3.title': '3. 정품 인증',
  'terms.section3.body': '모든 Rx.K Seoul 제품에는 고유한 인증 코드가 동봉되어 있습니다. 이 코드는 원래 구매자의 일회용 인증을 위해 제공됩니다. 인증 코드를 복제, 복사 또는 변조하려는 시도는 법적 조치를 초래할 수 있습니다. 미인증 판매처에서 구매한 제품은 인증, 보증 또는 지원 서비스 대상이 아닐 수 있습니다.',
  'terms.section4.title': '4. 배송 및 전달',
  'terms.section4.body': `당사는 방글라데시 내 주소 및 선택된 국제 목적지로 배송합니다. 표준 배송은 다카 지역 내 5영업일, 다카 외 지역은 10영업일이 소요되며, 이는 예상치이며 보장되지 않습니다. 물품의 분실 위험 및 소유권은 운송업체에 인도되는 시점에 귀하에게 이전됩니다. 당사는 통관, 기상 조건 또는 당사가 통제할 수 없는 기타 상황으로 인한 지연에 대해 책임을 지지 않습니다.

방글라데시 내 ৳3,000 이상 주문 시 무료 배송이 제공됩니다. 기타 모든 주문은 결제 시 표시된 표준 배송료가 적용됩니다.`,
  'terms.section5.title': '5. 반품, 환불 및 주문 취소',
  'terms.section5.body': `미사용 및 미개봉 제품은 배송일로부터 7일 이내에 전액 환불을 위해 반품할 수 있습니다. 제품은 원래 포장 상태이며 모든 실링과 인증 코드가 그대로 있어야 합니다. 사용, 개봉 또는 손상된 제품은 결함이 아닌 한 반품 대상이 아닙니다. 반품 제품을 수령하고 검수한 후 7~10 영업일 이내에 원 결제 수단으로(대금교환(COD) 주문의 경우 비카시/계좌이체로) 환불이 처리됩니다.

주문은 발송 전이라면 주문번호와 함께 support@rxkseoul.com으로 연락하여 무료로 취소할 수 있습니다. 이미 발송된 주문은 취소할 수 없으며, 위의 반품 절차가 대신 적용됩니다.`,
  'terms.section6.title': '6. 지식재산권',
  'terms.section6.body': '본 웹사이트의 모든 콘텐츠(텍스트, 그래픽, 로고, 이미지, 제품 설명, 소프트웨어 등 포함)는 주식회사 더케이서울 또는 그 라이선스 제공자의 재산이며, 저작권, 상표권 및 기타 지식재산권 법률에 의해 보호됩니다. 무단 사용, 복제 또는 배포는 엄격히 금지됩니다.',
  'terms.section7.title': '7. 책임의 한계',
  'terms.section7.body': '관련 법률이 허용하는 최대 범위 내에서, 주식회사 더케이서울은 제품 또는 서비스 이용과 관련하여 발생하는 간접, 부수적, 특별, 결과적 또는 징벌적 손해에 대해 책임을 지지 않습니다. 당사의 총 책임은 해당 청구의 원인이 된 특정 제품 또는 서비스에 대해 귀하가 지불한 금액을 초과하지 않습니다.',
  'terms.section8.title': '8. 제3자 광고 및 정보 공유',
  'terms.section8.body': '본 웹사이트는 제3자 광고를 허용하지 않습니다. 당사는 귀하의 개인정보를 제3자의 마케팅 목적으로 판매하거나 공유하지 않습니다. 결제 게이트웨이나 배송업체와 같은 제3자 서비스와의 연동은 주문 이행에 필요한 범위로 한정되며, 해당 제3자에게 직접 제공한 정보의 처리에 대해서는 그 제3자가 별도로 책임을 집니다.',
  'terms.section9.title': '9. 준거법',
  'terms.section9.body': '본 이용약관은 대한민국 법률에 따라 규율되고 해석됩니다. 본 약관에 따른 분쟁은 대한민국 서울 법원의 전속 관할에 따릅니다.',
  'terms.section10.title': '10. 문의하기',
  'terms.section10.body': '본 이용약관에 대한 질문이 있으시면 support@rxkseoul.com으로 문의해 주세요.',
  // ===== AUTH =====
  'auth.login.title': '로그인',
  'auth.login.subtitle': 'Rx.K Seoul에 오신 것을 환영합니다',
  'auth.login.email': '이메일',
  'auth.login.password': '비밀번호',
  'auth.login.remember': '로그인 상태 유지',
  'auth.login.forgot': '비밀번호를 잊으셨나요?',
  'auth.login.submit': '로그인',
  'auth.login.orSocial': '또는 소셜 계정으로',
  'auth.login.comingSoon': '준비 중',
  'auth.login.noAccount': '아직 계정이 없으신가요?',
  'auth.login.registerLink': '회원가입',
  'auth.login.success': '환영합니다!',
  'auth.login.error': '이메일 또는 비밀번호가 올바르지 않습니다',

  'auth.register.title': '회원가입',
  'auth.register.subtitle': 'Rx.K Seoul의 특별한 혜택을 누려보세요',
  'auth.register.email': '이메일',
  'auth.register.name': '이름',
  'auth.register.phone': '전화번호',
  'auth.register.password': '비밀번호',
  'auth.register.confirmPassword': '비밀번호 확인',
  'auth.register.terms': '이용약관에 동의합니다 (필수)',
  'auth.register.privacy': '개인정보 처리방침에 동의합니다 (필수)',
  'auth.register.marketing': '마케팅 이메일 및 SMS 수신에 동의합니다 (선택)',
  'auth.register.submit': '회원가입',
  'auth.register.hasAccount': '이미 계정이 있으신가요?',
  'auth.register.loginLink': '로그인',
  'auth.register.success': '가입을 환영합니다!',
  'auth.register.error': '회원가입에 실패했습니다. 다시 시도해 주세요.',

  'auth.forgot.title': '비밀번호 재설정',
  'auth.forgot.subtitle': '이메일을 입력하시면 재설정 링크를 보내드립니다',
  'auth.forgot.email': '이메일',
  'auth.forgot.submit': '재설정 링크 보내기',
  'auth.forgot.sent': '등록된 이메일로 재설정 링크를 보냈습니다.',
  'auth.forgot.backToLogin': '로그인으로 돌아가기',

  // ===== MY PAGE =====
  'my.dashboard': '대시보드',
  'my.joinDate': '가입일',
  'my.grade': '등급',
  'my.mileageBalance': '마일리지 잔액',
  'my.logout': '로그아웃',
  'my.recentOrders': '최근 주문',
  'my.orderDetail': '주문 상세',
  'my.pending': '대기 중',
  'my.tracking': '송장번호',
  'my.reorder': '재구매',

  'my.profile.title': '프로필 설정',
  'my.profile.info': '개인 정보',
  'my.profile.language': '언어',
  'my.profile.saved': '프로필이 업데이트되었습니다',
  'my.profile.password': '비밀번호 변경',
  'my.profile.currentPassword': '현재 비밀번호',
  'my.profile.newPassword': '새 비밀번호',
  'my.profile.confirmNewPassword': '새 비밀번호 확인',
  'my.profile.changePassword': '비밀번호 업데이트',
  'my.profile.passwordChanged': '비밀번호가 변경되었습니다',

  'my.orders.title': '주문내역',
  'my.orders.empty': '주문 내역이 없습니다',

  'my.mileage.title': '마일리지',
  'my.mileage.balance': '현재 잔액',
  'my.mileage.history': '거래 내역',
  'my.mileage.empty': '거래 내역이 없습니다',
  'my.mileage.expires': '만료일',
  'my.mileage.earn': '적립',
  'my.mileage.use': '사용',
  'my.mileage.expire': '소멸',
  'my.mileage.adjust': '조정',
  'my.mileage.policy1.title': '구매금액 10% 적립',
  'my.mileage.policy1.desc': '모든 구매 시 결제금액의 10%를 마일리지로 적립합니다',
  'my.mileage.policy2.title': '리뷰 적립',
  'my.mileage.policy2.desc': '제품 리뷰 작성 시 보너스 마일리지를 드립니다',
  'my.mileage.policy3.title': '생일 쿠폰',
  'my.mileage.policy3.desc': '매년 생일에 특별 마일리지 선물을 드립니다',

  'my.qna.title': 'Q&A',
  'my.qna.empty': '문의 내역이 없습니다',
  'my.qna.answered': '답변 완료',
  'my.qna.pending': '대기 중',
  'my.qna.formHint': '새로운 문의가 있으신가요? 더 빠른 처리를 위해 직접 문의해 주세요.',

  'common.save': '저장',

  'checkout.guestModal.title': '결제 방식을 선택해 주세요',
  'checkout.guestModal.subtitle': '로그인하면 더 빠른 결제와 마일리지 적립이 가능합니다',
  'checkout.guestModal.continue': '비회원으로 계속하기',
  'checkout.guestNoMileage': '비회원 결제 시 마일리지 적립이 불가합니다',
  'checkout.earnMileage': '이 주문으로',

  // ===== CHECKOUT — 주문 접수 (컨트롤 코어) =====
  'checkout.placing': '주문을 접수하는 중...',
  'checkout.error.insufficientStock': '죄송합니다. 방금 재고가 소진된 상품이 있습니다. 장바구니를 수정한 뒤 다시 시도해 주세요.',
  'checkout.error.codBlocked': '이 번호는 착불(COD) 결제를 이용할 수 없습니다. 계속 진행하려면 온라인 결제를 이용해 주세요 — 아래에 온라인 결제 수단을 선택해 두었습니다.',
  'checkout.error.network': '서버에 연결하지 못했습니다. 인터넷 연결을 확인한 뒤 다시 시도해 주세요.',
  'checkout.error.server': '주문 처리 중 문제가 발생했습니다. 잠시 후 다시 시도해 주세요.',
  'checkout.error.validation': '주문을 처리할 수 없습니다. 입력 정보를 확인한 뒤 다시 시도해 주세요.',
  'checkout.error.config': '현재 주문을 받을 수 없습니다. 잠시 후 다시 시도해 주세요.',

} as const;